import { BlocoUsuario } from './BlocoUsuario.js';
import { IconeArmazem, IconeCalendario, IconeMenuLateral } from '../componentes/Icones.js';
import { formatarDataLonga } from '../componentes/datas.js';
import './BarraSuperior.css';

type Props = {
  readonly nomeTenant: string;
  readonly navRecolhida: boolean;
  readonly aoAlternarNav: () => void;
};

/**
 * Barra superior da folha: recolhe o trilho, situa a pessoa (tenant e data) e
 * guarda a identidade com a saída.
 *
 * É a ÚNICA barra com a ação de sair — antes ela vivia no cabeçalho de cada
 * tela, e a tela de detalhe em tela cheia ficava sem ela.
 */
export function BarraSuperior({ nomeTenant, navRecolhida, aoAlternarNav }: Props) {
  const rotulo = navRecolhida ? 'Expandir menu' : 'Recolher menu';

  return (
    <header className="barra-superior">
      <button
        type="button"
        className="barra-superior__alternar"
        aria-label={rotulo}
        title={rotulo}
        aria-pressed={navRecolhida}
        onClick={aoAlternarNav}
      >
        <IconeMenuLateral tamanho={18} />
      </button>

      <span className="barra-superior__tenant">
        <IconeArmazem tamanho={15} />
        <span className="barra-superior__tenant-nome">{nomeTenant}</span>
      </span>

      <span className="barra-superior__data">
        <IconeCalendario tamanho={15} />
        {formatarDataLonga(new Date())}
      </span>

      <div className="barra-superior__direita">
        <BlocoUsuario />
      </div>
    </header>
  );
}
